
import { ref, onMounted } from "vue";
import Player from "@vimeo/player";

export default {
  name: "VideoPlayer",
  props: {
    videoThumbnailUrl: {
      type: String,
      required: false,
    },
    vimeoId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    let player: Player | undefined;
    const playerRef = ref(null);
    const isPlaying = ref<boolean>(false);
    onMounted(() => {
      if (props.vimeoId && playerRef?.value) {
        const options = {
          id: props.vimeoId,
          loop: false,
          controls: true,
          muted: true,
          autoplay: false,
        };

        player = new Player(playerRef.value, options);
      }
    });

    const play = () => {
      player?.play().then(() => {
        isPlaying.value = true;
      });
    };

    const pause = () => {
      player?.pause();
      isPlaying.value = false;
    };

    return {
      player,
      isPlaying,
      playerRef,
      play,
      pause,
    };
  },
};
